/* eslint-disable max-statements */
/* eslint-disable complexity */
import React, { useState, useEffect } from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";
import Button from "../../shared/button";
import { makeOdometerLabelAU } from "../../../utils/helpers/make-odometer-label";
import { makePriceLabelRound } from "../../../utils/helpers/make-price-label";
import Tooltip from "../../shared/tooltip";
import { getTooltipInfoList, getPersonalisedTooltipInfoList } from "../../../utils/helpers/car-properties";
import InfoOutline from "./images/info-outline.svg";
import WhiteTickIcon from "./../../shared/images/white-tick.svg";
import { useHistory } from "react-router-dom";
import IconHeart from "../../shared/icon-heart/component";
import { AU_DESKTOP_EVENTS } from "../../../tracking/au.desktop-events";
import { getCarPrice } from "../../../utils/helpers/calculate-egc-dap";

import loadable from "@loadable/component";
import { AB_TEST_VARIATIONS, NUMBER, ORDER_TYPE } from "../../../constants/app-constants";
import ThreeDayDeliveryPopup from "../three-day-delivery-popup/component";
import InfoIcon from "./images/info-icon.svg";
import ServiceIcon from "./images/service.svg";
import TransparentButton from "../../shared/button/transparent-button";
const EGCPriceView = loadable(() => import("../egc-price-view"));
import { getAbExpirementVariant, showNewTestDriveVariant, showTestDriveVariant } from "../../../utils/helpers/get-ab-expirement-variant";
import HowToBookTestModal from "../how-to-book-test-modal";
import TestDriveFaqModal from "../test-drive-faq-modal/component";
import { getTestDriveCheckoutURL, getTestDriveV2CheckoutURL } from "../../../utils/helpers/get-detail-page-url";
import { testDriveRoutes } from "../../../constants/au.desktop/test-drive-routes";
import { LOGIN_TYPE, ORDER_STATUS } from "../../../constants/checkout-constants";
const KbbPriceScreen = loadable(() => import("../../shared/kbb-price-screen/component"));
import { modelYearNameGenerator } from "../../../utils/helpers/model-year-name-generator";
import { testDriveV2Routes } from "../../../constants/au.desktop/test-drive-v2-routes";
import { getTestDriveCtaText } from "../../../utils/helpers/get-test-drive-cta-text";
import TrackImpression from "../../shared/track-impression";
import { CDP_REVAMP_AMPLITUDE_EVENTS } from "../../../tracking/amplitude-events";
import { trackDesktopCustomEventsAU } from "../../../tracking";
import { EVENT_DATA, EVENT_NAME } from "./tracking";
import useUserGeoLocation from "../../../hooks/use-user-geo-location";
import TrendingImage from "./images/trending-down.svg";
import { EXPERIMENT_TYPE } from "../../../constants/optimize-constants";
import LocationIcon from "./images/location.svg";
import backArrow from "./images/arrow-back.svg";
const HubLocationModal = loadable(() => import("../hub-loaction-modal"));
import useCarHighlightLocation from "../../../hooks/use-car-highlight-location";
import PriceDropCdpCard from "../../shared/price-drop-cdp-card";
import { PRICE_DROP_SOURCE } from "../../shared/price-drop-cdp-card/constants";

const CarDetailsCardRevamp = ({
    content,
    isWishlisted,
    onWishlistClick,
    ctaProps,
    imageHost,
    deliveryInfo,
    source,
    order,
    setLoginTypeConnect,
    tradeInToggleSelected,
    createOrderConnect,
    isUserZeroDpVariant,
    isFetchingOrderDetails,
    isLoggedIn,
    personalDetails,
    updateProfileConnect,
    secureToken,
    orderId,
    calculatorRef,
    scrollToSection,
    updateValidC2bOrderConnect,
    webPriceDropDesktop,
    testDriveConfig
}) => {
    const { shippingPrice = 0, pickupCharges } = deliveryInfo || {};
    const history = useHistory();
    const {
        appointmentId,
        make,
        model,
        modelYear,
        year,
        variant,
        transmissionType,
        odometerReading,
        bodyType,
        emiDetails,
        price,
        egc = 0,
        personalised,
        estimatedPrice = 0,
        kbbAskingPrice,
        serviceHistory = [],
        kbbValueProvidedOn,
        isPriceDrop,
        priceMeta = {},
        promotion,
        cityCode = ""
    } = content || {};
    const {deliveryMode, testDriveStatus = ""} = order || {};
    const userGeoData = useUserGeoLocation();
    const { state: { name: userState = {}} = {}, country: { isoCode: countryCode } = {}} = userGeoData || {};
    const isTestDriveVariant = showTestDriveVariant({ content, order });
    const {eligibleStateNames = [], enabledForIndia: isTestDriveEnabledForIndia = false} = testDriveConfig?.data || {};
    const isNewTestDriveLocationVariant = showNewTestDriveVariant({ content, order, userState, countryCode, isTestDriveEnabledForIndia, eligibleStateNames });
    const { emiPerWeek, defaultDownPayment } = emiDetails || {};
    const modelYearName = modelYearNameGenerator(modelYear);
    const [showHubLocationModal, setShowHubLocationModal] = useState(false);

    const {currentCarCityInfo = {}} = useCarHighlightLocation(cityCode);
    const cityHub = currentCarCityInfo || {};

    const hubCityName = cityHub?.cityName || "Unknown location";
    const carName = `${year} ${make} ${model} ${modelYearName}`;
    const kbbMarketPrice = kbbAskingPrice - egc;
    const showKbbMarketPrice = egc < kbbAskingPrice && kbbMarketPrice >=  NUMBER.FIVE_HUNDRED && kbbMarketPrice < NUMBER.TEN_THOUSAND;
    const onSale = promotion === "On sale";

    const [showEcgPrice, setShowEcgPrice] = useState(false);
    const [toolTipTitle, setToolTipTitle] = useState("");
    const [toolTipBody, setToolTipBody] = useState([]);
    const [showExpressDeliveryPopup, setShowExpressDeliveryPopup] = useState(false);
    const [showKBBModal, setShowKBBModal] = useState(false);
    const [showTestDriveLocationInfo, setShowTestDriveLocationInfo] = useState(false);

    const [showTestDriveModal, setShowTestDriveModal] = useState(false);
    const [showFaqModal, setShowFaqModal] = useState(false);
    const tooltipRef = React.useRef(null);
    const [eventCategory, setEventCategory] = useState({});
    const showWebPriceDesktop =
    getAbExpirementVariant(webPriceDropDesktop, EXPERIMENT_TYPE.VARIANT_B);

    const initialListingPrice = priceMeta?.referencePrice || {};

    const handleModal = () => {
        setShowTestDriveModal(!showTestDriveModal);
    };

    const handleFaqModal = () => {
        setShowFaqModal(!showFaqModal);
    };

    const handleGetPreApprovalClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        history.push("/financing/get-pre-approval");
    };

    const BottomLink = () => {
        return (
            <div
                styleName={"styles.bottomLink"}>
                <span>Want to know your exact finance rates?</span>
                <Button text="GET PRE-APPROVAL" leftImage={WhiteTickIcon} onClick={handleGetPreApprovalClick} btnView="new" />
                <small>No impact on your credit score</small>
            </div>
        );
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (tooltipRef.current && !tooltipRef.current.contains(event.target)) {
                setShowTestDriveLocationInfo(false);
            } else if (tooltipRef.current?.contains(event.target)) {
                if (showTestDriveLocationInfo) {
                    setShowTestDriveLocationInfo(false);
                } else {
                    setShowTestDriveLocationInfo(true);
                }
            }
        };
        document.addEventListener("click", handleClickOutside, false);
        return () => {
            document.removeEventListener("click", handleClickOutside, false);
        };

    }, [showTestDriveLocationInfo]);

    useEffect(() => {
        if (personalised) {
            setToolTipTitle(`Weekly payment of ${makePriceLabelRound(emiPerWeek)}`);
            setToolTipBody(getPersonalisedTooltipInfoList(emiDetails));
        } else {
            setToolTipTitle(`Weekly payment of ${makePriceLabelRound(emiPerWeek)}`);
            setToolTipBody(getTooltipInfoList(emiDetails, isUserZeroDpVariant).concat(<BottomLink />));
        }
    }, [emiPerWeek, emiDetails, personalised, isUserZeroDpVariant]);

    const handleEgcView = () => {
        setShowEcgPrice(!showEcgPrice);
    };

    const handleShowPop = () => {
        setShowExpressDeliveryPopup(!showExpressDeliveryPopup);
    };

    const onClickTestDrive = async () => {
        const { relativeURL } = getTestDriveCheckoutURL(content, testDriveRoutes.basicDetails.route);
        history.push(relativeURL);
        setLoginTypeConnect(LOGIN_TYPE.TEST_DRIVE);
    };

    const displayIcon = () => {
        if (!ctaProps.iconType) {
            return (null);
        } else if (ctaProps.iconType === "Info") {
            return (
                <div styleName={"styles.hovertext"}>
                    <div styleName={"styles.infoicon"}>
                        <img src={InfoIcon} alt={InfoIcon} />
                    </div>
                    <div styleName={"styles.paraContent styles.top_arrow"}>
                        <p>You can choose to be notified if this car becomes available to purchase in the near future</p>
                    </div>
                </div>
            );
        } else {
            return (<div styleName={"styles.wishlistBtn"}>
                <IconHeart
                    active={isWishlisted}
                    onClick={onWishlistClick}
                    source="cdp_revamp_gradient"
                />
            </div>);
        }
    };

    const handleOpenMarketModal = () => {
        setShowKBBModal(!showKBBModal);
    };

    const getProfilePayload = () => {
        const { firstName, lastName } = personalDetails || {};
        return {
            ...personalDetails,
            firstName: firstName ?  firstName.trim() : "",
            lastName: lastName ? lastName.trim() : ""
        };
    };
    const updateProfile = async (payload) => {
        try {
            await updateProfileConnect(payload, secureToken);
        } catch (error) {
            throw error;
        }
    };

    const onClickTestDriveV2 = async () => {
        let redirectUrl = "";
        if (testDriveStatus === ORDER_STATUS.BOOKED) {
            const {relativeURL: bookingConfirmationRoute} = getTestDriveV2CheckoutURL(content, testDriveV2Routes.bookingConfirmed.route);
            redirectUrl = bookingConfirmationRoute;
        } else {
            //* Should be fired before "purchase started" event inside createOrderConnect(orderPayload) below
            trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.TEST_DRIVE_V2_CTA_SELECTED, {
                eventLabel: "test_drive",
                eventAction: "cta_selected"
            });
            trackDesktopCustomEventsAU(EVENT_NAME.CHECKOUT_INITIATED, EVENT_DATA.CHECKOUT_INITIATED);
            if (isLoggedIn) {
                const orderPayload = {
                    vehiclePrice: getCarPrice({egcPrice: content.egc, dapPrice: content.price }).egc.value,
                    appointmentId,
                    orderType: ORDER_TYPE.PRODUCT_TEST_DRIVE,
                    tdUserType: AB_TEST_VARIATIONS.TEST

                };
                const  profilePayload  = getProfilePayload();
                try {
                    if (orderId) {
                        await updateProfile(profilePayload);
                    } else {
                        await createOrderConnect(orderPayload);
                    }
                } catch (error) {
                    // setLoading(false);
                }
            }
            const { relativeURL: basicDetailsRoute } = getTestDriveV2CheckoutURL(content, testDriveV2Routes.basicDetails.route);
            redirectUrl = basicDetailsRoute;
            updateValidC2bOrderConnect(secureToken);
        }
        history.push(redirectUrl);
    };

    const getDefaultButtonStyle = () => {
        if (ctaProps.transparentButton || isTestDriveVariant || isNewTestDriveLocationVariant) {
            return "styles.defaultButtonWithTransparent";
        } else {
            return "styles.defaultButtonWithoutTransparent";
        }
    };

    const getServiceDate = (inputDate) => {
        const dateArray = inputDate.split("/");
        return `${dateArray[NUMBER.ONE] }/${ dateArray[NUMBER.TWO]}`;
    };
    const onClickFinanceInfo = () => {
    };
    useEffect(() => {
        if (isNewTestDriveLocationVariant) {
            setEventCategory(AU_DESKTOP_EVENTS.BUY_ONLINE_CTA_CLICKED);
        } else if (source === "gallery") {
            setEventCategory(AU_DESKTOP_EVENTS.CAR_GALLERY_VIEW);
        } else {
            setEventCategory(AU_DESKTOP_EVENTS.CAR_DETAILS_ATF_INTERACTIONS);
        }
    }, [isNewTestDriveLocationVariant, source]);

    const handleHubLocationArrowClick = () => {
        setShowHubLocationModal(true);
    };

    const handleOnHubLocationModalClose = () => {
        setShowHubLocationModal(false);
    };

    return (
        <React.Fragment>
            <div styleName={`styles.carCard`}>
                <div>
                    <div styleName={"styles.carnameWrapper"}>
                        <h1 styleName={"styles.carName"}> {carName} </h1>
                    </div>
                    <ul styleName={"styles.variantList"}>
                        <li>{makeOdometerLabelAU(odometerReading)}</li>
                        <li>{bodyType}</li>
                        <li>{transmissionType}</li>
                        <li>{variant}</li>
                    </ul>
                </div>
                {serviceHistory?.[0]?.serviceDate && <div styleName="styles.serviceWrapper">
                    <div styleName={"styles.serviceHistoryIcon"}>
                        <img src={ServiceIcon} alt={InfoIcon} />
                    </div>
                    <div styleName="styles.serviceHistory">Last service : {getServiceDate(serviceHistory[0].serviceDate)}</div>
                </div>}

                <div styleName={"styles.carCardBottomContentWrapper"}>
                    <div styleName={`${onSale ? "styles.salePriceWrap" : ""}`}>
                        <p styleName="styles.dapLabel">Excl. Govt. Charges</p>
                        <div styleName={"styles.leftTopSection"}>
                            <p styleName={"styles.priceContainer"}>
                                <span styleName="styles.tradeInEstimatePrice">
                                    {tradeInToggleSelected ? makePriceLabelRound(estimatedPrice) : getCarPrice({ egcPrice: egc, dapPrice: price, shippingPrice, pickupCharges, deliveryMode }).egc.label}
                                </span>
                                {onSale && (
                                    <span styleName="styles.salePriceStrike">{makePriceLabelRound(price)}</span>
                                )}
                                {isPriceDrop && showWebPriceDesktop  && (
                                    <span styleName="styles.salePriceStrike">{makePriceLabelRound(initialListingPrice)}</span>
                                )}
                            </p>
                            {/* <p styleName={"styles.govtCharge"}>Excl. Govt. Charges</p> */}
                            {showKbbMarketPrice && !showWebPriceDesktop &&
                            <div styleName={"styles.stickerWrapper"}>
                                <img src={TrendingImage} />
                                <p styleName={"styles.marketPrice"}>{makePriceLabelRound(kbbMarketPrice)}</p>
                                <button styleName={"styles.belowMarket"} onClick={handleOpenMarketModal}>BELOW MARKET*</button>
                            </div>
                            }
                        </div>
                        {isPriceDrop && showWebPriceDesktop ? <div styleName={"styles.priceDropcard"}><PriceDropCdpCard source={PRICE_DROP_SOURCE.DESKTOP}/></div> : null}
                        <p styleName={"styles.priceBreakUp"} onClick={() => handleEgcView()}>See price break down</p>
                        <p styleName={"styles.financingLabel"} >Financing</p>
                        <div styleName={"styles.zeroDpInfo"}>
                            <p styleName={"styles.zeroDPWeekly"}>{makePriceLabelRound(emiPerWeek)}/week</p>
                            <div styleName="styles.infoTooltip">
                                <Tooltip onClickCallback={onClickFinanceInfo} customStyleHeading={true} heading={toolTipTitle} body={toolTipBody}>
                                    <img styleName="styles.infoTooltipIcon" src={InfoOutline} alt="Weekly Payment" />
                                </Tooltip>
                            </div>
                            <p styleName="styles.bestInterestRateLabel"><span>%</span> BEST INTEREST RATES</p>
                        </div>
                        {defaultDownPayment === NUMBER.ZERO  &&  <p styleName={"styles.zeroDeposit"}>$0 deposit</p>}
                        <p styleName="styles.priceBreakUp" onClick={() => scrollToSection(calculatorRef)}>Loan Calculator</p>
                    </div>
                    <TrackImpression event={{ name: CDP_REVAMP_AMPLITUDE_EVENTS.GET_STARTED_CTA_VIEWED }}>
                        <div styleName={`styles.buttonWrap ${isTestDriveVariant ? "styles.test-drive-paading" : ""}`}>
                            {isTestDriveVariant  ? <div styleName={"styles.test-drive"}>
                                <TransparentButton
                                    text={"TEST DRIVE"}
                                    disabled={ctaProps.disabled}
                                    isLoading={ctaProps.isLoading}
                                    onClick={onClickTestDrive} />
                                <div styleName={"styles.wishlistBtn-test-drive"}>
                                    <IconHeart active={isWishlisted} onClick={onWishlistClick} source="wishlist" />
                                </div>
                            </div> : displayIcon()}
                            {ctaProps.transparentButton ?
                                <div styleName={`styles.transparentBtns`}>
                                    <TransparentButton
                                        text={ctaProps.text}
                                        disabled={ctaProps.disabled}
                                        isLoading={ctaProps.isLoading}
                                        onClick={(e) => ctaProps.action(eventCategory, e)} /> </div>
                                :
                                <div styleName={"styles.buttonContainer"}>
                                    { isNewTestDriveLocationVariant && !isTestDriveVariant && isTestDriveEnabledForIndia &&  (
                                        <React.Fragment>
                                            { !isFetchingOrderDetails ?
                                                <div styleName="styles.transparentBtns">
                                                    <TransparentButton
                                                        text={getTestDriveCtaText(ORDER_STATUS[testDriveStatus])}
                                                        disabled={ctaProps.disabled}
                                                        isLoading={ctaProps.isLoading}
                                                        onClick={onClickTestDriveV2}
                                                    />
                                                </div> : <div className="shimmer"  styleName={"styles.ctaShimmer"} /> }
                                        </React.Fragment>
                                    )}
                                    <div styleName={getDefaultButtonStyle()}>
                                        <Button
                                            text={ctaProps.text}
                                            disabled={ctaProps.disabled}
                                            isLoading={ctaProps.isLoading}
                                            onClick={(e) => ctaProps.action(eventCategory, e)}
                                        />
                                    </div>
                                </div>
                            }
                        </div>
                    </TrackImpression>
                    <div onClick={handleHubLocationArrowClick} styleName={"styles.parkedLocationWrapper"}>
                        <p styleName={"styles.parkedLocation"}><img src={LocationIcon} alt="Location icon" />Parked at {hubCityName} hub </p>
                        <img src={backArrow} alt="Back arrow image" />
                    </div>
                    {/* <p styleName={"styles.returnPolicy"}>7 day return policy</p> */}
                </div>
            </div>

            {showEcgPrice &&
                    <EGCPriceView
                        {...content}
                        onClose={handleEgcView}
                        config={{ imageHost }}
                        type=""
                        bodyType={content.body || content.bodyType}
                        cta={ctaProps}
                    />}

            {
                showExpressDeliveryPopup &&
                    <ThreeDayDeliveryPopup handleShowPop={handleShowPop} />
            }
            {showTestDriveModal && <HowToBookTestModal handleFaqModal={handleFaqModal} onClose={handleModal} onClickTestDrive={onClickTestDrive} />}
            {showFaqModal && <TestDriveFaqModal onClose={handleFaqModal} onClickTestDrive={onClickTestDrive} />}

            {showKBBModal &&
                <KbbPriceScreen
                    onClose={handleOpenMarketModal}
                    egc={egc}
                    kbbAskingPrice={kbbAskingPrice}
                    kbbValueProvidedOn={kbbValueProvidedOn}
                />}
            {
                showHubLocationModal &&
                <HubLocationModal cityHubInfo={cityHub} onClose={handleOnHubLocationModalClose} />
            }
            <div />
        </React.Fragment>

    );
};

CarDetailsCardRevamp.propTypes = {
    content: PropTypes.object,
    ctaProps: PropTypes.object,
    history: PropTypes.object,
    order: PropTypes.string,
    isWishlisted: PropTypes.bool,
    onWishlistClick: PropTypes.func,
    onClickNotifyIcon: PropTypes.func,
    comingSoon: PropTypes.bool,
    personalised: PropTypes.bool,
    handleKbbModal: PropTypes.func,
    imageHost: PropTypes.string,
    source: PropTypes.string,
    deliveryInfo: PropTypes.object,
    onSale: PropTypes.bool,
    saleConfig: PropTypes.object,
    isKbbShown: PropTypes.bool,
    isGalleryOpen: PropTypes.bool,
    isUserZeroDpVariant: PropTypes.bool,
    onClose: PropTypes.func,
    updateSelectedOnScreenFilterConnect: PropTypes.func,
    reloadCarListConnect: PropTypes.func,
    updateAllFiltersVisibilityConnect: PropTypes.func,
    resetCarListConnect: PropTypes.func,
    updateAppliedFiltersConnect: PropTypes.func,
    allFilters: PropTypes.object,
    selectedFilters: PropTypes.object,
    selectedCity: PropTypes.string,
    setLoginTypeConnect: PropTypes.func,
    createOrderConnect: PropTypes.func,
    secureToken: PropTypes.func,
    createTestDriveAvailabilityConnect: PropTypes.func,
    tradeInToggleSelected: PropTypes.bool,
    isFetchingOrderDetails: PropTypes.bool,
    isLoggedIn: PropTypes.bool,
    personalDetails: PropTypes.object,
    updateProfileConnect: PropTypes.func,
    getOrderDetailConnect: PropTypes.func,
    orderId: PropTypes.string,
    calculatorRef: PropTypes.object,
    scrollToSection: PropTypes.func,
    updateValidC2bOrderConnect: PropTypes.func,
    webPriceDropDesktop: PropTypes.object,
    cityHubInfo: PropTypes.object,
    testDriveConfig: PropTypes.object
};

export default CarDetailsCardRevamp;
